import { client } from '@connected/api-client';
import {
    getAuthentication,
    setAuthentication,
} from '@connected/api-client/lib/authentication';
import {
    queryOptions as tanstackQueryOptions,
    useQuery as useTanstackQuery,
    useSuspenseQuery as useTanstackSuspenseQuery,
} from '@tanstack/react-query';

function queryOptions() {
    return tanstackQueryOptions({
        queryKey: ['retrieveAccountInfo'],
        queryFn: async () => {
            const authentication = getAuthentication();

            if (authentication)
                setAuthentication(authentication);

            const result = await client.GET('/api/v2/accounts/info');

            if (!result.error)
                return result.data.Info ?? null;

            return null;
        },
    });
}

const useQuery = () => useTanstackQuery(queryOptions());
const useSuspenseQuery = () => useTanstackSuspenseQuery(queryOptions());

export const me = {
    queryOptions,
    useQuery,
    useSuspenseQuery,
};
